module.exports = __webpack_public_path__ + "static/media/mapa-contact.853eb8fe.svg";